var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchOptionalLegacyProps } from '../config';
var BrowserAuthApiError = /** @class */ (function (_super) {
    __extends(BrowserAuthApiError, _super);
    function BrowserAuthApiError(message, status) {
        var _this = _super.call(this, message) || this;
        _this.name = 'BrowserAuthApiError';
        _this.status = status;
        Object.setPrototypeOf(_this, BrowserAuthApiError.prototype);
        return _this;
    }
    return BrowserAuthApiError;
}(Error));
export { BrowserAuthApiError };
var trimTrailingSlash = function (host) { return host.replace(/\/+$/, ''); };
var getBrowserAuthHost = function () {
    var props = fetchOptionalLegacyProps();
    var host = (props === null || props === void 0 ? void 0 : props.browser_auth_host) || (props === null || props === void 0 ? void 0 : props.server_api_host) || (props === null || props === void 0 ? void 0 : props.oauth_api_host) || '';
    return trimTrailingSlash(host);
};
export var browserAuthUrl = function (path) {
    var normalizedPath = path.replace(/^\/+/, '');
    var host = getBrowserAuthHost();
    if (!host) {
        return "/api/v1/auth/" + normalizedPath;
    }
    return host + "/api/v1/auth/" + normalizedPath;
};
var isJsonResponse = function (response) {
    var contentType = response.headers.get('content-type');
    return !!contentType && contentType.indexOf('application/json') !== -1;
};
var readErrorMessage = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!isJsonResponse(response)) {
                    return [2 /*return*/, null];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, response.json()];
            case 2:
                data = _b.sent();
                return [2 /*return*/, ((_a = data === null || data === void 0 ? void 0 : data.errors) === null || _a === void 0 ? void 0 : _a.global)
                        || (data === null || data === void 0 ? void 0 : data.detail)
                        || (data === null || data === void 0 ? void 0 : data.title)
                        || (data === null || data === void 0 ? void 0 : data.error)
                        || null];
            case 3:
                e_1 = _b.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var jsonHeaders = function () { return [
    ['Accept', 'application/json'],
    ['Content-Type', 'application/json'],
]; };
var acceptJsonHeaders = function () { return [
    ['Accept', 'application/json'],
]; };
var assertSuccessfulResponse = function (response, fallbackMessage) { return __awaiter(void 0, void 0, void 0, function () {
    var message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (response.ok) {
                    return [2 /*return*/, response];
                }
                return [4 /*yield*/, readErrorMessage(response)];
            case 1:
                message = _a.sent();
                throw new BrowserAuthApiError(message || fallbackMessage, response.status);
        }
    });
}); };
var translateFetchError = function (error, fallbackMessage) {
    if (error instanceof BrowserAuthApiError) {
        throw error;
    }
    throw new BrowserAuthApiError(fallbackMessage);
};
export var loginBrowserSession = function (credentials) { return __awaiter(void 0, void 0, void 0, function () {
    var fallbackMessage, response, invalidCredentials, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fallbackMessage = 'Kunne ikke opprette innloggingen. Prøv igjen.';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch(browserAuthUrl('login'), {
                        method: 'POST',
                        credentials: 'include',
                        headers: jsonHeaders(),
                        body: JSON.stringify({
                            email: credentials.email,
                            password: credentials.password,
                            rememberMe: credentials.rememberMe,
                        }),
                    })];
            case 2:
                response = _a.sent();
                invalidCredentials = response.status === 400
                    || response.status === 401
                    || response.status === 403;
                return [2 /*return*/, assertSuccessfulResponse(response, invalidCredentials ? 'Feil passord eller epostadresse' : fallbackMessage)];
            case 3:
                error_1 = _a.sent();
                return [2 /*return*/, translateFetchError(error_1, fallbackMessage)];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var logoutBrowserSession = function () { return __awaiter(void 0, void 0, void 0, function () {
    var fallbackMessage, response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fallbackMessage = 'Kunne ikke logge ut av innloggingstjenesten.';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetch(browserAuthUrl('logout'), {
                        method: 'POST',
                        credentials: 'include',
                        headers: acceptJsonHeaders(),
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, assertSuccessfulResponse(response, fallbackMessage)];
            case 3:
                error_2 = _a.sent();
                return [2 /*return*/, translateFetchError(error_2, fallbackMessage)];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchBrowserAuthMe = function () { return __awaiter(void 0, void 0, void 0, function () {
    var fallbackMessage, response, data, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fallbackMessage = 'Kunne ikke hente innlogget bruker.';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetch(browserAuthUrl('me'), {
                        credentials: 'include',
                        headers: acceptJsonHeaders(),
                    })];
            case 2:
                response = _a.sent();
                if (response.status === 401 || response.status === 403) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, assertSuccessfulResponse(response, fallbackMessage)];
            case 3:
                _a.sent();
                return [4 /*yield*/, response.json()];
            case 4:
                data = _a.sent();
                return [2 /*return*/, (data === null || data === void 0 ? void 0 : data.user) || null];
            case 5:
                error_3 = _a.sent();
                return [2 /*return*/, translateFetchError(error_3, fallbackMessage)];
            case 6: return [2 /*return*/];
        }
    });
}); };
